const ALLOCATION_ITEM_DELIMITER = '-';

export default ALLOCATION_ITEM_DELIMITER;
